/*
* ApplicationDetailsUploadBinaries.jsx
* Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
* All rights reserved.
*/
import React, { useEffect, useState } from "react";
import { Grid2, Typography, Container, Button, Backdrop, CircularProgress } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { fetchSubmissionDetails } from "../../Services/redux/Application-details/ApplicationDetailsActions";
import {
  fetchBinaryKeyDetails,
  fetchDeleteBinaryKeyDetails,
} from "../../Services/redux/binaryDetails/BinaryDetailsActions";
import { FileUploader } from "react-drag-drop-files";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ApplicationDetailsErrorDialog from "../ApplicationDetailsErrorDialog/ApplicationDetailsErrorDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import "./ApplicationDetailsUploadBinaries.css";

function ApplicationDetailsUploadBinaries() {
  const dispatch = useDispatch();
  const appData = useSelector(
    (state) => state.applicationDetails.applicationDetails
  );
  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails
  );
  const { loading, binaryKeyData } = useSelector(
    (state) => state.binaryKeyDetails
  );
  const errors = useSelector((state) => state.errors);
  const [appId, setAppId] = useState("");
  const [submissionId, setSubmissionId] = useState("");
  const [binaryKey, setBinaryKey] = useState([]);
  const handleFileChange = (file) => {
    dispatch(fetchBinaryKeyDetails(appId, submissionId, file));
  };

  useEffect(() => {

    if (appId && appId.length > 0 && sessionStorage.getItem("submissionId")) {
      dispatch(fetchSubmissionDetails(appId, submissionId));
    }
  }, [ binaryKeyData]);

  const monthNames = [
    "Jan",
    "Feb",
    "March",
    "Apr",
    "May",
    "June",
    "July",
    "August",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    setAppId(appData.id);
    if (submissionData && Object.keys(submissionData).length > 0) {
      if (submissionData.binaries) {
        const binryKey = Object.keys(submissionData.binaries);
        setBinaryKey([...binryKey]);
      }
    }
    setSubmissionId(submissionData.id);
  }, [appData, submissionData]);

  const deletebinary = (binaryKey) => {
    dispatch(fetchDeleteBinaryKeyDetails(appId, submissionId, binaryKey));
  };

  return (
    <Container maxWidth="lg">
      <Grid2 container justifyContent="flex-start" alignItems="center">
        <Grid2 size={12}>
          <section id="signedapkfiles">
            <Typography
              sx={{
                "font-weight": "bold !important",
                "font-size": "20px !important",
                // "letter-spacing": "0.4px !important",
                color: "rgba(18, 20, 21, 1) !important",
                "margin-left": "10% !important",
              }}
              className="uploadSignedApkText"
            >
              Signed APK Files
            </Typography>
            <Typography
              sx={{
                "font-weight": "400 !important",
                "font-size": "12px !important",
                "lineHeight":'19.6px !important',
                // "letter-spacing": "0.4px !important",
                color: "rgba(90, 91, 92, 1) !important",
                "margin-left": "10% !important",
              }}
              className="uploadSignedApkText"
            >
              Upload one or more multiple signed version of APK files. Only signatures with V1, V2 and V3 schemes are supported.
            </Typography>
            <div className="APKfileUploadSection">
              {loading ? (
                <Backdrop
                  sx={(theme) => ({
                    color: "#fff",
                    zIndex: theme.zIndex.drawer + 1,
                  })}
                  open={loading}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              ) : (
                <div>
                  <div className="fileUploadFileDivUploadBaniaries">
                    <FileUploader
                      classes="fileContentClsUploadBinaries"
                      multiple={false}
                      handleChange={handleFileChange}
                      name="file"
                      label="Drag and drop the file here or Browse"
                      uploadedLabel="Uploaded Successfully!"
                    />
                  </div>
                  <div>
                    <div className="Apkscetion-uploadbinaries">
                      {binaryKey &&
                        binaryKey.length > 0 &&
                        binaryKey.map((binariesKey) => {
                          return (
                            <div className="info" key={binariesKey}>
                              <div className="application-name-div">
                                <div className="application">
                                  <span className="submit-date">Key</span>
                                  <span className="binary-key-data">
                                    {binariesKey}
                                  </span>
                                </div>
                              </div>
                              <div>
                                  <span className="submit-date">Submitted</span>
                                  <span className="date-text-binary">{(() => {
                                    const date = new Date(submissionData.lastModified);
                                    return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
                                  })()}</span>
                                </div>
                              <div className="buttons-list">
                                <button className="download" style={{ color: "inherit" }}>
                                <a
                                    href={
                                      submissionData?.binaries?.[binariesKey]?.url || ""
                                    }
                                    className="download-link"
                                    style={{
                                      color: "inherit !important",
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      textDecoration: "none",
                                    }}
                                  >
                                    <FileDownloadOutlinedIcon
                                      style={{
                                        color: "white",
                                        fontSize: 15,
                                        marginRight: 3,
                                        marginTop: 2,
                                      }}
                                    />
                                    Download
                                  </a>
                                  </button>
                                <Button
                                  onClick={() => deletebinary(binariesKey)}
                                  sx={{
                                    color: "rgba(181, 11, 0, 1) !important",
                                  }}
                                >
                                  <DeleteIcon />
                                </Button>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
              {errors?.errorMessage != null &&
                errors?.errorType != null && <ApplicationDetailsErrorDialog />}
            </div>
          </section>
        </Grid2>
      </Grid2>
    </Container>
  );
}

export default ApplicationDetailsUploadBinaries;

